import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { Button } from '@/components/ui/Button/button';
import openModal from '@/modals/utils/openModal';
import lockDailyWidget from '@/public/assets/image/daily-bonuses/lock-daily-widget.webp';

const GmBarDesktopStub = () => {
  const t = useTranslations('daily-bonus');

  return (
    <div className="absolute py-2 px-4 inset-0 z-10 flex h-full flex-col items-center justify-between text-center">
      <div className="flex flex-col gap-1.5">
        <div className="flex items-center justify-center shrink-0 max-md:mt-2">
          <Image src={lockDailyWidget} alt="Lock" className="size-8" />
        </div>
        <div className="flex flex-col">
          <p className="font-semibold text-white leading-4 text-[0.75rem] mt-0.5">{t('sign-up-to-unlock-daily-bonuses')}</p>
          <p className="text-white text-center flex justify-center items-center gap-1 leading-4 font-medium text-[0.625rem]">
            {t('earn-up-to')}
            {' '}
            <span className="font-semibold text-base leading-[120%] text-transparent bg-clip-text bg-main-front-gradient">75 SC</span>
            {' '}
            {t('every-day')}
          </p>
        </div>
      </div>
      <Button variant="primary" size="lg" className="w-full py-3 md:py-1.5" onClick={() => openModal('register')}>
        {t('sign-up-and-claim')}
      </Button>
    </div>
  );
};
export default GmBarDesktopStub;
